import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthLayoutComponent } from '@fantaz/auth/layout';

@Component({
  standalone: true,
  imports: [RouterOutlet, AuthLayoutComponent],
  selector: 'fz-auth-shell',
  template: `
    <div class="games_background">
      <div class="games_background__bg">
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
        <div class="games_background__bg__tile"></div>
      </div>
      <div class="games_background__overlay"></div>
    </div>
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./shell.component.scss'],
  host: {
    class: 'fz-auth-shell',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthShellComponent {}
